import {
  focusVisibleSelector
} from "./chunk.ZX7YPA4S.js";

// src/styles/button-colors.styles.ts
import { css } from "lit";
var button_colors_styles_default = css`
	/*
  * Priority & Color
  */

	/*** Primary ***/

	/* Brand */
	.button--primary.button--brand {
		background-color: var(--yotpo-color-brand-70);
		border-color: var(--yotpo-color-brand-70);
		color: var(--yotpo-color-white);
	}

	.button--primary.button--brand:hover:not(.button--disabled) {
		background-color: var(--yotpo-color-brand-80);
		border-color: var(--yotpo-color-brand-80);
		color: var(--yotpo-color-white);
	}

	.button--primary.button--brand${focusVisibleSelector}:not(.button--disabled) {
		background-color: var(--yotpo-color-brand-70);
		border-color: var(--yotpo-color-brand-70);
		color: var(--yotpo-color-white);
		box-shadow: var(--yotpo-focus-global);
	}

	.button--primary.button--brand:active:not(.button--disabled) {
		background-color: var(--yotpo-color-brand-90);
		border-color: var(--yotpo-color-brand-90);
		color: var(--yotpo-color-white);
	}

	/* Destructive */
	.button--primary.button--destructive {
		background-color: var(--yotpo-color-destructive-70);
		border-color: var(--yotpo-color-destructive-70);
		color: var(--yotpo-color-white);
	}

	.button--primary.button--destructive:hover:not(.button--disabled) {
		background-color: var(--yotpo-color-destructive-80);
		border-color: var(--yotpo-color-destructive-80);
		color: var(--yotpo-color-white);
	}

	.button--primary.button--destructive${focusVisibleSelector}:not(.button--disabled) {
		background-color: var(--yotpo-color-destructive-70);
		border-color: var(--yotpo-color-destructive-70);
		color: var(--yotpo-color-white);
		box-shadow: var(--yotpo-focus-global);
	}

	.button--primary.button--destructive:active:not(.button--disabled) {
		background-color: var(--yotpo-color-destructive-90);
		border-color: var(--yotpo-color-destructive-90);
		color: var(--yotpo-color-white);
	}

	/* Premium */
	.button--primary.button--premium {
		background-color: var(--yotpo-color-premium-70);
		border-color: var(--yotpo-color-premium-70);
		color: var(--yotpo-color-white);
	}

	.button--primary.button--premium:hover:not(.button--disabled) {
		background-color: var(--yotpo-color-premium-80);
		border-color: var(--yotpo-color-premium-80);
		color: var(--yotpo-color-white);
	}

	.button--primary.button--premium${focusVisibleSelector}:not(.button--disabled) {
		background-color: var(--yotpo-color-premium-70);
		border-color: var(--yotpo-color-premium-70);
		color: var(--yotpo-color-white);
		box-shadow: var(--yotpo-focus-global);
	}

	.button--primary.button--premium:active:not(.button--disabled) {
		background-color: var(--yotpo-color-premium-90);
		border-color: var(--yotpo-color-premium-90);
		color: var(--yotpo-color-white);
	}

	/* Dark */
	.button--primary.button--dark {
		background-color: var(--yotpo-color-general-100);
		border-color: var(--yotpo-color-general-100);
		color: var(--yotpo-color-white);
	}

	.button--primary.button--dark:hover:not(.button--disabled) {
		background-color: var(--yotpo-color-general-90);
		border-color: var(--yotpo-color-general-90);
		color: var(--yotpo-color-white);
	}

	.button--primary.button--dark${focusVisibleSelector}:not(.button--disabled) {
		background-color: var(--yotpo-color-general-100);
		border-color: var(--yotpo-color-general-100);
		color: var(--yotpo-color-white);
		box-shadow: var(--yotpo-focus-global);
	}

	.button--primary.button--dark:active:not(.button--disabled) {
		background-color: var(--yotpo-color-general-80);
		border-color: var(--yotpo-color-general-80);
		color: var(--yotpo-color-white);
	}

	/* Disabled */
	.button--primary.button--disabled {
		background-color: var(--yotpo-color-disabled);
		border-color: var(--yotpo-color-disabled);
		color: var(--yotpo-color-white);
	}

	/*** Secondary & Tertiary ***/

	/* Brand */
	.button--secondary.button--brand,
	.button--tertiary.button--brand {
		background-color: transparent;
		color: var(--yotpo-color-brand-70);
	}

	.button--secondary.button--brand:hover:not(.button--disabled),
	.button--tertiary.button--brand:hover:not(.button--disabled) {
		background-color: var(--yotpo-color-brand-10);
		color: var(--yotpo-color-brand-70);
	}

	.button--secondary.button--brand${focusVisibleSelector}:not(.button--disabled),
	.button--tertiary.button--brand${focusVisibleSelector}:not(.button--disabled) {
		background-color: transparent;
		color: var(--yotpo-color-brand-70);
		box-shadow: var(--yotpo-focus-global);
	}

	.button--secondary.button--brand:active:not(.button--disabled),
	.button--tertiary.button--brand:active:not(.button--disabled) {
		background-color: var(--yotpo-color-brand-20);
		color: var(--yotpo-color-brand-70);
	}

	/* Destructive */
	.button--secondary.button--destructive,
	.button--tertiary.button--destructive {
		background-color: transparent;
		color: var(--yotpo-color-destructive-70);
	}

	.button--secondary.button--destructive:hover:not(.button--disabled),
	.button--tertiary.button--destructive:hover:not(.button--disabled) {
		background-color: var(--yotpo-color-destructive-10);
		color: var(--yotpo-color-destructive-70);
	}

	.button--secondary.button--destructive${focusVisibleSelector}:not(.button--disabled),
	.button--tertiary.button--destructive${focusVisibleSelector}:not(.button--disabled) {
		background-color: transparent;
		color: var(--yotpo-color-destructive-70);
		box-shadow: var(--yotpo-focus-global);
	}

	.button--secondary.button--destructive:active:not(.button--disabled),
	.button--tertiary.button--destructive:active:not(.button--disabled) {
		background-color: var(--yotpo-color-destructive-20);
		color: var(--yotpo-color-destructive-70);
	}

	/* Premium */
	.button--secondary.button--premium,
	.button--tertiary.button--premium {
		background-color: transparent;
		color: var(--yotpo-color-premium-70);
	}

	.button--secondary.button--premium:hover:not(.button--disabled),
	.button--tertiary.button--premium:hover:not(.button--disabled) {
		background-color: var(--yotpo-color-premium-10);
		color: var(--yotpo-color-premium-70);
	}

	.button--secondary.button--premium${focusVisibleSelector}:not(.button--disabled),
	.button--tertiary.button--premium${focusVisibleSelector}:not(.button--disabled) {
		background-color: transparent;
		color: var(--yotpo-color-premium-70);
		box-shadow: var(--yotpo-focus-global);
	}

	.button--secondary.button--premium:active:not(.button--disabled),
	.button--tertiary.button--premium:active:not(.button--disabled) {
		background-color: var(--yotpo-color-premium-20);
		color: var(--yotpo-color-premium-70);
	}

	/* Dark */
	.button--secondary.button--dark,
	.button--tertiary.button--dark {
		background-color: transparent;
		color: var(--yotpo-color-general-100);
	}

	.button--secondary.button--dark:hover:not(.button--disabled),
	.button--tertiary.button--dark:hover:not(.button--disabled) {
		background-color: var(--yotpo-color-general-10);
		color: var(--yotpo-color-general-100);
	}

	.button--secondary.button--dark${focusVisibleSelector}:not(.button--disabled),
	.button--tertiary.button--dark${focusVisibleSelector}:not(.button--disabled) {
		background-color: transparent;
		color: var(--yotpo-color-general-100);
		box-shadow: var(--yotpo-focus-global);
	}

	.button--secondary.button--dark:active:not(.button--disabled),
	.button--tertiary.button--dark:active:not(.button--disabled) {
		background-color: var(--yotpo-color-general-20);
		color: var(--yotpo-color-general-100);
	}

	/* Disabled */
	.button--secondary.button--disabled,
	.button--tertiary.button--disabled {
		background-color: transparent;
		color: var(--yotpo-color-disabled);
	}

	/*** Secondary ***/

	/* Brand */
	.button--secondary.button--brand {
		border-color: var(--yotpo-color-brand-70);
	}

	/* Destructive */
	.button--secondary.button--destructive {
		border-color: var(--yotpo-color-destructive-70);
	}

	/* Premium */
	.button--secondary.button--premium {
		border-color: var(--yotpo-color-premium-70);
	}

	/* Dark */
	.button--secondary.button--dark {
		border-color: var(--yotpo-color-general-100);
	}

	/* Disabled */
	.button--secondary.button--disabled {
		border-color: var(--yotpo-color-disabled);
	}

	/*** Tertiary ***/

	.button--tertiary {
		border-color: transparent !important;
	}
`;

export {
  button_colors_styles_default
};
